var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSmileyFrustrated(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16,0A16,16,0,1,0,32,16,16.018,16.018,0,0,0,16,0Zm0,29.34A13.34,13.34,0,1,1,29.34,16,13.356,13.356,0,0,1,16,29.34Zm-7.532-14.3,2.992-2.992L8.468,9.061,10.348,7.18l3.933,3.932a1.33,1.33,0,0,1,0,1.881l-3.933,3.933Zm9.252-2.052a1.33,1.33,0,0,1,0-1.881L21.652,7.18l1.881,1.881L20.54,12.053l2.992,2.992-1.881,1.881ZM25.079,23.5l-2.395,1.157c-1.032-2.136-3.723-3.571-6.7-3.571s-5.666,1.435-6.7,3.57L6.893,23.5c1.488-3.082,5.058-5.073,9.093-5.073S23.59,20.423,25.079,23.5Z",
    fill: "#0071B9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSmileyFrustrated);
export default __webpack_public_path__ + "static/media/icon-smiley-frustrated.ad932d576753a701b94399d5478f6d20.svg";
export { ForwardRef as ReactComponent };